export default function () {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Castorama',
        url: process.env.baseUrl,
        logo: `${process.env.PUBLIC_PATH}standalone-images/logo.png`,
        telephone: '+48 22 528 58 00',
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'ul. Krakowiaków 78',
            addressLocality: 'Warszawa',
            postalCode: '02-255',
            addressCountry: {
                '@type': 'Country',
                name: 'PL',
            },
        },
        sameAs: [
            'https://www.youtube.com/user/CastoramaPolska',
            'https://www.facebook.com/CastoramaPolska',
            'https://www.instagram.com/castoramapolska',
            'https://pl.linkedin.com/company/castorama-polska-sp-z-o-o-',
        ],
    };
}
